module.exports = __webpack_public_path__ + "media/images/pic/video/3-d1bbfea731c7397d54c6b765ffe47ed8.jpeg";